// extracted by mini-css-extract-plugin
module.exports = {"flexGap":"style_flexGap__1W2L7"};